import * as React from "react";
import type { SVGProps } from "react";

const FacilitySport = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6484 6.1543L13.8461 8.35196L8.35136 13.8467L6.1537 11.649L11.6484 6.1543Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.74723 9.56039C3.1112 9.19642 3.7013 9.19642 4.06527 9.56039L10.4396 15.9347C10.8036 16.2987 10.8036 16.8888 10.4396 17.2528L10.1094 17.583C9.74546 17.947 9.15535 17.947 8.79138 17.583L2.41703 11.2086C2.05306 10.8447 2.05306 10.2546 2.41703 9.89059L2.74723 9.56039Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.74723 12.8573C3.1112 12.4933 3.7013 12.4933 4.06527 12.8573L7.14314 15.9351C7.5071 16.2991 7.50711 16.8892 7.14314 17.2532L6.81294 17.5834C6.44897 17.9473 5.85886 17.9473 5.49489 17.5834L2.41703 14.5055C2.05306 14.1415 2.05306 13.5514 2.41703 13.1875L2.74723 12.8573Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2528 10.4406C16.8888 10.8046 16.2987 10.8046 15.9347 10.4406L9.56037 4.06623C9.1964 3.70226 9.1964 3.11215 9.56037 2.74819L9.89057 2.41799C10.2545 2.05402 10.8446 2.05402 11.2086 2.41799L17.583 8.79234C17.9469 9.15631 17.9469 9.74642 17.583 10.1104L17.2528 10.4406Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.2528 7.14273C16.8888 7.5067 16.2987 7.5067 15.9347 7.14273L12.8569 4.06487C12.4929 3.7009 12.4929 3.11079 12.8569 2.74682L13.1871 2.41663C13.551 2.05266 14.1411 2.05266 14.5051 2.41663L17.583 5.49449C17.9469 5.85846 17.9469 6.44857 17.583 6.81254L17.2528 7.14273Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilitySport.displayName = "FacilitySport";

export default FacilitySport;
